import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-app-store',
  templateUrl: './app-store.component.html',
  styleUrls: ['./app-store.component.scss']
})
export class AppStoreComponent {
  @Input() feature: any;
  @Output() featureChange = new EventEmitter<any>();

  ngOnInit() {
    if (!this.feature.value) {
      this.feature.value = {
        google: '',
        apple: ''
      };
    }
  }

  onGoogleLinkChange() {
    this.featureChange.emit(this.feature);
  }

  onAppleLinkChange() {
    this.featureChange.emit(this.feature);
  }

  isValidUrl(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }
}